/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Save_Offer_BodyInputs */

const en_cancel_save_offer_body = /** @type {(inputs: Cancel_Save_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep your data and resumes. We'll pause billing for 1 month so you can come back when you're ready.`)
};

const de_cancel_save_offer_body = /** @type {(inputs: Cancel_Save_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behalte deine Daten und Lebenslaeufe. Wir pausieren die Abrechnung fuer 1 Monat.`)
};

const fr_cancel_save_offer_body = /** @type {(inputs: Cancel_Save_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garde tes donnees et CV. Nous mettons la facturation en pause pendant 1 mois.`)
};

const es_cancel_save_offer_body = /** @type {(inputs: Cancel_Save_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conserva tus datos y CVs. Pausamos la facturacion por 1 mes.`)
};

const it_cancel_save_offer_body = /** @type {(inputs: Cancel_Save_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantieni i tuoi dati e CV. Mettiamo in pausa la fatturazione per 1 mese.`)
};

const nl_cancel_save_offer_body = /** @type {(inputs: Cancel_Save_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewaar je gegevens en CV's. We pauzeren de facturering voor 1 maand.`)
};

const pl_cancel_save_offer_body = /** @type {(inputs: Cancel_Save_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zachowaj dane i CV. Wstrzymamy platnosci na 1 miesiac.`)
};

const fi_cancel_save_offer_body = /** @type {(inputs: Cancel_Save_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sailyta tietosi ja ansioluettelosi. Tauotamme laskutuksen 1 kuukaudeksi.`)
};

const da_cancel_save_offer_body = /** @type {(inputs: Cancel_Save_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behold dine data og CV'er. Vi sætter faktureringen på pause i 1 måned, så du kan komme tilbage, når du er klar.`)
};

const sv_cancel_save_offer_body = /** @type {(inputs: Cancel_Save_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behåll dina data och CV. Vi pausar faktureringen i 1 månad.`)
};

/**
* | output |
* | --- |
* | "Keep your data and resumes. We'll pause billing for 1 month so you can come back when you're ready." |
*
* @param {Cancel_Save_Offer_BodyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_save_offer_body = /** @type {((inputs?: Cancel_Save_Offer_BodyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Save_Offer_BodyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_save_offer_body(inputs)
	if (locale === "fr") return fr_cancel_save_offer_body(inputs)
	if (locale === "es") return es_cancel_save_offer_body(inputs)
	if (locale === "it") return it_cancel_save_offer_body(inputs)
	if (locale === "nl") return nl_cancel_save_offer_body(inputs)
	if (locale === "pl") return pl_cancel_save_offer_body(inputs)
	if (locale === "fi") return fi_cancel_save_offer_body(inputs)
	if (locale === "da") return da_cancel_save_offer_body(inputs)
	if (locale === "sv") return sv_cancel_save_offer_body(inputs)
	return en_cancel_save_offer_body(inputs)
});